/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 *  Possible values: Scheduled = 1, Completed = 2, Cancelled = 3, NoShow = 4, OnTheWay = 5, InProgress = 6, Archived = 7
 */
export enum Routemize_Constants_AppointmentStatus {
    SCHEDULED = 'Scheduled',
    COMPLETED = 'Completed',
    CANCELLED = 'Cancelled',
    NO_SHOW = 'NoShow',
    ON_THE_WAY = 'OnTheWay',
    IN_PROGRESS = 'InProgress',
    ARCHIVED = 'Archived',
}
